import type { Film } from "@/types/content";

export const filmRegions = ["国内", "港台", "欧美", "日韩"];

export const filmGenres = [
  "剧情",
  "喜剧",
  "动作",
  "科幻",
  "悬疑",
  "爱情",
  "历史",
  "动画",
  "犯罪",
  "冒险",
  "都市",
  "青春",
  "运动",
];

export const filmYears = [
  { label: "全部年份", value: "all" },
  { label: "近五年", value: "5" },
  { label: "近十年", value: "10" },
];

export const films: Film[] = [
  {
    id: "film-01",
    title: "星海回声",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20an%20astronaut%20floating%20above%20a%20luminous%20ocean%20planet%2C%20deep%20navy%20blue%20palette%20with%20warm%20orange%20glow%2C%20minimal%20dramatic%20composition%2C%20clean%20gradient%20background%2C%20high%20detail%20editorial%20poster%20aesthetic&width=600&height=900&seq=film-01&orientation=portrait",
    year: 2025,
    region: "国内",
    genres: ["科幻", "冒险"],
    rating: 8.9,
    heat: 9820,
    director: "顾长天",
    castIds: ["star-02", "star-01", "star-06"],
    summary:
      "一支深空探测队在遥远星系捕捉到一段循环往复的神秘信号，信号中竟藏着人类未来的答案。",
    synopsis: [
      "《星海回声》把镜头对准了一支即将退役的深空探测队。在任务最后阶段，他们捕捉到一段来自未知星系的循环信号，这段信号无法被任何已知物理模型解释。",
      "随着调查深入，队员们发现信号与地球上一位已故科学家的研究笔记高度吻合，一场关于时间、记忆与选择的冒险由此展开。",
      "影片以克制的叙事与震撼的视觉呈现，讨论人在浩瀚宇宙中的渺小与执着。",
    ],
    updatedAt: "2025-09-28",
    tags: ["科幻", "深空", "年度期待", "信号之谜"],
  },
  {
    id: "film-02",
    title: "长夜将明",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20detective%20in%20a%20long%20coat%20walking%20through%20a%20foggy%20night%20alley%2C%20deep%20blue%20shadows%20with%20amber%20lamp%20light%2C%20suspenseful%20mood%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail%20poster%20aesthetic&width=600&height=900&seq=film-02&orientation=portrait",
    year: 2024,
    region: "国内",
    genres: ["悬疑", "犯罪"],
    rating: 8.6,
    heat: 8760,
    director: "陆铭",
    castIds: ["star-04", "star-03"],
    summary:
      "一名老刑警在退休前的最后七天，被迫重启一桩尘封十五年的旧案。",
    synopsis: [
      "《长夜将明》围绕老刑警周策退休前的最后七天展开。一封信的到来，让一桩十五年前的悬案重新浮出水面。",
      "作品并不依赖血腥与刺激，而是通过耐心的询问与大量的沉默，让真相一点点拼合。",
      "导演陆铭用冷峻的镜头语言，讲述了一个关于责任与和解的故事。",
    ],
    updatedAt: "2025-08-16",
    tags: ["悬疑", "刑侦", "口碑", "旧案"],
  },
  {
    id: "film-03",
    title: "山河故人梦",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lone%20traveler%20on%20ancient%20misty%20mountains%2C%20historical%20epic%20mood%2C%20deep%20blue%20haze%20with%20warm%20golden%20light%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail%20poster%20aesthetic&width=600&height=900&seq=film-03&orientation=portrait",
    year: 2023,
    region: "国内",
    genres: ["剧情", "历史"],
    rating: 9.1,
    heat: 7540,
    director: "陈砚",
    castIds: ["star-06", "star-05"],
    summary:
      "一座古城的兴衰，三代人的离散与重逢，写尽百年家国记忆。",
    synopsis: [
      "《山河故人梦》以一座南方古城为舞台，讲述三代人在时代洪流中的离散与重逢。",
      "影片用细腻的笔墨描绘日常，让宏大的历史落在每一顿饭、每一封信与每一次告别里。",
      "凭借扎实的剧本与出色的群像表演，该片被誉为近年最具分量的历史剧情片之一。",
    ],
    updatedAt: "2025-06-02",
    tags: ["历史", "年代", "群像", "获奖"],
  },
  {
    id: "film-04",
    title: "都市浮生",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20cheerful%20young%20professional%20crossing%20a%20busy%20modern%20city%20crosswalk%2C%20deep%20blue%20buildings%20with%20warm%20orange%20sunlight%2C%20lighthearted%20mood%2C%20clean%20gradient%20background%2C%20high%20detail%20poster%20aesthetic&width=600&height=900&seq=film-04&orientation=portrait",
    year: 2025,
    region: "国内",
    genres: ["都市", "喜剧"],
    rating: 7.8,
    heat: 6890,
    director: "何未",
    castIds: ["star-08", "star-09"],
    summary:
      "四个合租青年在大城市里鸡飞狗跳又互相扶持的日常。",
    synopsis: [
      "《都市浮生》讲的是四个性格迥异的年轻人挤在同一间出租屋里的故事。",
      "工作、房租、恋爱与梦想轮番轰炸，笑点密集的同时也藏着成年人不易言说的疲惫。",
      "剧集节奏轻快，台词贴近生活，是下班后的解压首选。",
    ],
    updatedAt: "2025-09-11",
    tags: ["都市", "轻喜剧", "合租", "下饭剧"],
  },
  {
    id: "film-05",
    title: "追风少年",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20teenage%20sprinter%20leaping%20on%20a%20running%20track%20at%20dawn%2C%20dynamic%20energy%2C%20deep%20blue%20tones%20with%20warm%20orange%20highlights%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail%20poster%20aesthetic&width=600&height=900&seq=film-05&orientation=portrait",
    year: 2024,
    region: "国内",
    genres: ["青春", "运动"],
    rating: 8.2,
    heat: 8120,
    director: "林跃",
    castIds: ["star-10", "star-07"],
    summary:
      "小镇少年凭一股不服输的劲头，跑进了国家队的跑道。",
    synopsis: [
      "《追风少年》讲述一名来自小镇的短跑少年，在教练与队友的帮助下冲击职业赛场的故事。",
      "影片把大量镜头留给了训练与汗水，让每一次冲刺都令人热血沸腾。",
      "这是一部关于坚持与团队的青春片，适合全家人一起观看。",
    ],
    updatedAt: "2025-07-19",
    tags: ["青春", "运动", "热血", "励志"],
  },
  {
    id: "film-06",
    title: "雾都疑影",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20tense%20crime%20scene%20under%20a%20single%20street%20lamp%20in%20heavy%20fog%2C%20dark%20blue%20palette%20with%20warm%20orange%20glow%2C%20mysterious%20mood%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail%20poster%20aesthetic&width=600&height=900&seq=film-06&orientation=portrait",
    year: 2022,
    region: "港台",
    genres: ["悬疑", "犯罪"],
    rating: 8.4,
    heat: 5210,
    director: "麦定威",
    castIds: ["star-04", "star-02"],
    summary:
      "浓雾笼罩的海港城市里，一桩连环案让两个立场对立的警探被迫合作。",
    synopsis: [
      "《雾都疑影》把舞台放在一座常年被浓雾笼罩的海港城市。",
      "两个办案风格截然不同的警探，因一桩连环案件不得不联手，矛盾与合作贯穿全片。",
      "影片气氛阴郁而克制，港片传统的类型张力在这里被拿捏得恰到好处。",
    ],
    updatedAt: "2025-05-08",
    tags: ["港片", "悬疑", "警匪", "冷峻"],
  },
  {
    id: "film-07",
    title: "时光信箱",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20nostalgic%20vintage%20mailbox%20glowing%20with%20warm%20light%20in%20soft%20rain%2C%20romantic%20fantasy%20mood%2C%20deep%20blue%20background%20with%20orange%20sparkle%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail&width=600&height=900&seq=film-07&orientation=portrait",
    year: 2025,
    region: "国内",
    genres: ["爱情", "奇幻"],
    rating: 7.6,
    heat: 9340,
    director: "温之然",
    castIds: ["star-01", "star-06"],
    summary:
      "一只旧信箱能让信件寄往过去，两个时空的年轻人因此相遇。",
    synopsis: [
      "《时光信箱》里，女主角在搬家时发现了一只旧信箱，投入其中的信竟能寄往十年前。",
      "她与过去的男孩通过书信往来，逐渐改变彼此的命运，也面对无法回避的取舍。",
      "影片用温柔的想象包裹现实议题，是近年少见的细腻爱情奇幻作品。",
    ],
    updatedAt: "2025-10-01",
    tags: ["爱情", "奇幻", "时空", "治愈"],
  },
  {
    id: "film-08",
    title: "逆光而行",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20determined%20figure%20walking%20against%20strong%20wind%20on%20a%20hill%20at%20sunrise%2C%20inspirational%20mood%2C%20deep%20blue%20tones%20with%20warm%20orange%20light%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail&width=600&height=900&seq=film-08&orientation=portrait",
    year: 2023,
    region: "国内",
    genres: ["剧情"],
    rating: 8.0,
    heat: 4320,
    director: "徐行",
    castIds: ["star-03", "star-08"],
    summary:
      "一位乡村教师在资源匮乏的条件下，守护着一间只有七个学生的教室。",
    synopsis: [
      "《逆光而行》取材于真实故事的灵感，讲述一位乡村教师坚守山村的岁月。",
      "面对撤点并校与家人的反对，她在坚持与放手之间反复挣扎。",
      "影片不刻意煽情，却处处让人动容，是一部值得静下心来看的作品。",
    ],
    updatedAt: "2025-04-22",
    tags: ["剧情", "现实", "教育", "治愈"],
  },
  {
    id: "film-09",
    title: "奇幻森林历险",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20movie%20poster%20art%20of%20a%20child%20exploring%20a%20magical%20glowing%20forest%20with%20friendly%20creatures%2C%20whimsical%20family%20mood%2C%20deep%20blue%20night%20with%20warm%20orange%20fireflies%2C%20clean%20gradient%20background%2C%20high%20detail&width=600&height=900&seq=film-09&orientation=portrait",
    year: 2024,
    region: "欧美",
    genres: ["动画", "家庭"],
    rating: 8.7,
    heat: 7980,
    director: "Liam Ford",
    castIds: ["star-07"],
    summary:
      "为寻找失踪的哥哥，小女孩闯入会发光的魔法森林，遇见一群古怪又温暖的伙伴。",
    synopsis: [
      "《奇幻森林历险》是一部合家欢动画电影，讲述小女孩为寻找哥哥而闯入魔法森林的冒险。",
      "森林里的每个角落都藏着会发光的秘密，也藏着关于勇气与成长的答案。",
      "精美的画面与动人的配乐，让它成为近年最受欢迎的动画作品之一。",
    ],
    updatedAt: "2025-03-30",
    tags: ["动画", "合家欢", "冒险", "唯美"],
  },
  {
    id: "film-10",
    title: "铁血荣光",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20soldiers%20silhouetted%20on%20a%20battlefield%20at%20dusk%2C%20war%20drama%20mood%2C%20deep%20blue%20smoke%20with%20warm%20orange%20embers%2C%20minimal%20composition%2C%20clean%20gradient%20background%2C%20high%20detail&width=600&height=900&seq=film-10&orientation=portrait",
    year: 2022,
    region: "国内",
    genres: ["历史", "动作"],
    rating: 9.0,
    heat: 6110,
    director: "高振",
    castIds: ["star-06", "star-10"],
    summary:
      "一支被遗忘的运输小队，在战火中用一条补给线撑起整场战役。",
    synopsis: [
      "《铁血荣光》聚焦一支鲜为人知的运输小队，他们负责的补给线是整场战役的生命线。",
      "影片用大量细节还原战场环境，也用心刻画每一个普通士兵的选择。",
      "没有过度渲染，只有沉甸甸的敬意。",
    ],
    updatedAt: "2025-02-14",
    tags: ["战争", "历史", "群像", "热血"],
  },
  {
    id: "film-11",
    title: "笑对人生",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%20of%20a%20smiling%20man%20shrugging%20in%20a%20bright%20living%20room%2C%20warm%20lighthearted%20mood%2C%20deep%20blue%20accents%20with%20warm%20orange%20tones%2C%20clean%20gradient%20background%2C%20high%20detail&width=600&height=900&seq=film-11&orientation=portrait",
    year: 2025,
    region: "国内",
    genres: ["喜剧"],
    rating: 7.4,
    heat: 5660,
    director: "何未",
    castIds: ["star-08", "star-05"],
    summary:
      "一个总把日子过砸的中年男人，决定用一年时间把自己的生活重新逗笑。",
    synopsis: [
      "《笑对人生》讲的是一个中年男人在失业后决定成为段子手的故事。",
      "他的每一次尝试都以失败告终，却让身边的人重新找回了笑的理由。",
      "影片笑中带泪，提醒观众认真生活本身就很了不起。",
    ],
    updatedAt: "2025-09-05",
    tags: ["喜剧", "治愈", "中年", "温情"],
  },
  {
    id: "film-12",
    title: "深海秘境",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20deep%20sea%20diver%20descending%20toward%20glowing%20underwater%20ruins%2C%20adventure%20mood%2C%20deep%20blue%20water%20with%20warm%20orange%20bioluminescence%2C%20minimal%20composition%2C%20high%20detail%20poster%20aesthetic&width=600&height=900&seq=film-12&orientation=portrait",
    year: 2024,
    region: "日韩",
    genres: ["科幻", "冒险"],
    rating: 8.1,
    heat: 7230,
    director: "佐藤一郎",
    castIds: ["star-02", "star-09"],
    summary:
      "一支国际科考队潜入万米海沟，发现了一座仍在运转的远古遗迹。",
    synopsis: [
      "《深海秘境》把镜头带到人类几乎无法抵达的万米海沟。",
      "科考队在那里发现了一座仍在运转的远古遗迹，随之而来的是一连串无法解释的现象。",
      "影片将硬核科幻与海洋奇观结合，视觉冲击力十足。",
    ],
    updatedAt: "2025-08-01",
    tags: ["科幻", "深海", "冒险", "视觉大片"],
  },
];